import { render } from "./ContentBuilderCreatePage.vue?vue&type=template&id=58b9060c"
import script from "./ContentBuilderCreatePage.vue?vue&type=script&lang=js"
export * from "./ContentBuilderCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__